"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.ParameterDefaultFlags = exports.IncompatibleFlags = exports.CompatibleFlags = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Unknown"] = 0] = "Unknown";
    MessageType[MessageType["FlagBits"] = 66] = "FlagBits";
    MessageType[MessageType["Information"] = 73] = "Information";
    MessageType[MessageType["FormatDefinition"] = 70] = "FormatDefinition";
    MessageType[MessageType["InformationMulti"] = 77] = "InformationMulti";
    MessageType[MessageType["Parameter"] = 80] = "Parameter";
    MessageType[MessageType["ParameterDefault"] = 81] = "ParameterDefault";
    MessageType[MessageType["AddLogged"] = 65] = "AddLogged";
    MessageType[MessageType["RemoveLogged"] = 82] = "RemoveLogged";
    MessageType[MessageType["Data"] = 68] = "Data";
    MessageType[MessageType["Log"] = 76] = "Log";
    MessageType[MessageType["LogTagged"] = 67] = "LogTagged";
    MessageType[MessageType["Synchronization"] = 83] = "Synchronization";
    MessageType[MessageType["Dropout"] = 79] = "Dropout";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var CompatibleFlags;
(function (CompatibleFlags) {
    CompatibleFlags[CompatibleFlags["DefaultParameters"] = 1] = "DefaultParameters";
})(CompatibleFlags = exports.CompatibleFlags || (exports.CompatibleFlags = {}));
var IncompatibleFlags;
(function (IncompatibleFlags) {
    IncompatibleFlags[IncompatibleFlags["AppendedData"] = 1] = "AppendedData";
})(IncompatibleFlags = exports.IncompatibleFlags || (exports.IncompatibleFlags = {}));
var ParameterDefaultFlags;
(function (ParameterDefaultFlags) {
    ParameterDefaultFlags[ParameterDefaultFlags["SystemWide"] = 1] = "SystemWide";
    ParameterDefaultFlags[ParameterDefaultFlags["CurrentConfigurationDefault"] = 2] = "CurrentConfigurationDefault";
})(ParameterDefaultFlags = exports.ParameterDefaultFlags || (exports.ParameterDefaultFlags = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Emerg"] = 0] = "Emerg";
    LogLevel[LogLevel["Alert"] = 1] = "Alert";
    LogLevel[LogLevel["Crit"] = 2] = "Crit";
    LogLevel[LogLevel["Err"] = 3] = "Err";
    LogLevel[LogLevel["Warning"] = 4] = "Warning";
    LogLevel[LogLevel["Notice"] = 5] = "Notice";
    LogLevel[LogLevel["Info"] = 6] = "Info";
    LogLevel[LogLevel["Debug"] = 7] = "Debug";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
//# sourceMappingURL=enums.js.map